export function BallparkPassportIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="12" y="8" width="24" height="32" rx="3" />
      <line x1="12" y1="14" x2="36" y2="14" />
      <circle cx="18" cy="22" r="2" fill="currentColor" />
      <circle cx="24" cy="22" r="2" fill="currentColor" />
      <circle cx="30" cy="22" r="2" fill="currentColor" />
      <circle cx="18" cy="28" r="2" fill="currentColor" />
      <circle cx="24" cy="28" r="2" fill="currentColor" />
      <circle cx="30" cy="28" r="2" />
      <circle cx="18" cy="34" r="2" />
      <circle cx="24" cy="34" r="2" />
      <circle cx="30" cy="34" r="2" />
    </svg>
  );
}
